import { render, staticRenderFns } from "./Flags.vue?vue&type=template&id=03491315&"
import script from "./Flags.vue?vue&type=script&lang=ts&"
export * from "./Flags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports